import { User } from '../../../user/user.model';
import { SearchParams } from '../../core';
import { defaultState } from '../landing.state';
import { ForMyTeamGridOptions } from '../model/for-my-team-grid-options.model';
import { GridOptions } from '../model/grid-options.model';
import { GridType } from '../model/grid-type.model';
import { Reload } from '../state/reload.action';

import { createSearchParams } from './create-search-params.function';

export function createReloadActionPayload(opts: { userId: number }): Reload {
    const user = new User();
    user.id = opts.userId;

    // key place to revise if the page state needs to be retained after unloading then later reloading the page
    const ds = defaultState();
    const grids: GridOptions[] = [ds.forMe, ds.byMe, ds.forMyTeam];
    const searchOpts = grids.map<{ type: GridType; params: SearchParams }>(
        (e) => {
            return {
                type: e.type,
                params: createSearchParams({
                    type: e.type,
                    days: e.days,
                    userId: user.id,
                    teamAlt:
                        e.type === GridType.FOR_MY_TEAM
                            ? (e as ForMyTeamGridOptions).teamAlt
                            : null,
                }),
            };
        },
    );

    return {
        user,
        searchOpts,
    };
}
